
define(['jquery', 'underscore', 'common/location'], function($, _, location) {
  var detectErrors, generateRedirectUrl;
  generateRedirectUrl = function() {
    return encodeURIComponent(window.location.href);
  };
  detectErrors = function(response, statusCode) {
    var isError, isOktaLogin, loginRedirectURL, oktaRedirectURL, sessionExpiredRedirectURL, _ref;
    isError = false;
    isOktaLogin = JSON.parse(window.localStorage.getItem('openid_okta'));
    oktaRedirectURL = "" + location.apiRoot + "/oauth2/authorization/okta?redirect_url=" + (generateRedirectUrl());
    loginRedirectURL = "" + location.websiteRoot + "/login?session_expired=true&redirect_url=" + (generateRedirectUrl());
    sessionExpiredRedirectURL = isOktaLogin != null ? isOktaLogin : {
      oktaRedirectURL: loginRedirectURL
    };
    if (statusCode === 401) {
      window.location = sessionExpiredRedirectURL;
      return true;
    }
    if (_.isString(response)) {
      try {
        response = JSON.parse(response);
      } catch (e) {

      }
    }
    if (_.isObject(response) && ((response.error != null) || (response.messages != null))) {
      if (((_ref = response.messages) != null ? _ref[0].message : void 0) === "Unauthorized Access") {
        $('<img>').attr('src', "/logout").appendTo('body');
        setTimeout(function() {
          return window.location = '/login?insufficient_security=true';
        }, 200);
      }
      switch (response.error) {
        case 'session_expired':
          window.location = sessionExpiredRedirectURL;
          isError = true;
          break;
        case 'impersonated_error':
          window.location = '/bk/';
          isError = true;
          break;
        case 'access_denied':
          window.location = '/app/';
          isError = true;
      }
    }
    if (_.isString(response) && response.indexOf('/logon') !== -1) {
      window.location = sessionExpiredRedirectURL;
      isError = true;
    }
    return isError;
  };
  return function(params) {
    if (params == null) {
      params = {};
    }
    $.sendAndReceiveJSON = function(settings) {
      if (params.useImpersonation) {
        settings.data.viewedImpersonatedUserId = params.currentClientId;
      }
      return $.ajax({
        contentType: 'application/json',
        url: settings.url,
        data: !_.isString(settings.data) ? JSON.stringify(settings.data) : settings.data,
        type: 'POST',
        success: function(data, statusCode) {
          if (detectErrors(data, statusCode)) {
            return;
          }
          if (_.isFunction(settings.success)) {
            return settings.success(data);
          }
        },
        error: function(data, statusCode, xhr) {
          if (detectErrors(data, statusCode)) {
            return;
          }
          if (_.isFunction(settings.error)) {
            return settings.error(data);
          }
        }
      });
    };
    $.receiveJSON = function(url, params, callback) {
      if (_.isFunction(params) && (callback == null)) {
        callback = params;
        params = {};
      }
      return $.sendAndReceiveJSON({
        url: url,
        data: params,
        success: callback
      });
    };
    return $(document).ajaxComplete(function(e, xhr, settings) {
      return detectErrors(xhr.responseText, xhr.status);
    });
  };
});
